import axios from '../helpers/public.axios';

import {
  GET_HOTEL_CONTENT,
  GET_HOTEL_RATES_ERR2,
  GET_HOTEL_RATES_REQ2,
  GET_HOTEL_RATES_RES2,
  // ##### 25-05-09 Komarov
  GET_HOTEL_RATES_ERR4,
  GET_HOTEL_RATES_REQ4,
  GET_HOTEL_RATES_RES4,
  RESET_HOTEL_RATES,
} from '../constants';
// ##### 25-01-14 Komarov
import { getPostObject } from '../../helpers/crypto';
// ##### 25-03-28 Komarov
import { postSavingDataClient } from '../../helpers/saveData';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';

// ##### 24-05-24 Komarov
export const hotelContent = res => ({
  type: GET_HOTEL_CONTENT,
  payload: res,
});

// ##### 24-06-10 Komarov
export const resetHotelrates = () => ({
  type: RESET_HOTEL_RATES,
});

// ##### 25-01-13 Komarov
export const getHotelRates2 =
  ({
    search_data,
    userId,
    sale,
    company_cipher,
    deviceType,
    refpartner,
    promocode,
    locale,
  }) =>
    async dispatch => {
      dispatch({ type: GET_HOTEL_RATES_REQ2 });
      const data = {
        // ##### Komarov 2025-05-26
        sale_id: sale || null,
        promocode,
        deviceType,
        company_cipher: company_cipher || '',
        start: search_data.start, // date of arrival
        end: search_data.end, // date of departure
        city_id: search_data.city_id,
        // ##### 25-04-21 Komarov
        hotel_id: search_data.id, // hotel's id
        calculation_data: {
          adults: search_data.adults,
          children: search_data.children,
          // ##### 25-03-11 Komarov
          // lower_cost_limit: 0.0, // lower cost limit of room in USD, NOT OBLIGATORY
          // upper_cost_limit: 200.0, // upper cost limit of room in USD, NOT OBLIGATORY
          quantity: search_data.rooms, // Quantity of rooms, 1 by default, NOT OBLIGATORY
        },
      };

      const postObject = getPostObject({
        action: 'GetHotelPriceAlphaRQ',
        user_id: userId,
        refpartner,
        language: locale,
        // ##### Komarov 2025-05-26
        sale: sale || null,
        data,
      });

      // ##### 25-04-30 Komarov
      uniLog(
        'hotelrates.js',
        'axios:src/Redux/actions/hotelrates.js:getHotelRates2, url:',
        postObject.url
      );

      // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
      await postSavingDataClient({
        postObject,
        typeRes: GET_HOTEL_RATES_RES2,
        typeErr: GET_HOTEL_RATES_ERR2,
        dispatch,
      });
    };

// ##### 25-05-09 Komarov
export const getHotelRates4 =
  ({
    search_data,
    userId,
    sale,
    company_cipher,
    deviceType,
    refpartner,
    promocode,
    locale,
    room_rq_id,
    tariff_rq_id,
  }) =>
    async dispatch => {
      dispatch({ type: GET_HOTEL_RATES_REQ4 });
      const data = {
        // ##### Komarov 2025-05-26
        sale_id: sale || null,
        promocode,
        deviceType,
        company_cipher: company_cipher || '',
        start: search_data.start, // date of arrival
        end: search_data.end, // date of departure
        city_id: search_data.city_id,
        // ##### 25-04-21 Komarov
        hotel_id: search_data.id, // hotel's id
        calculation_data: {
          adults: search_data.adults,
          children: search_data.children,
          // ##### 25-03-11 Komarov
          // lower_cost_limit: 0.0, // lower cost limit of room in USD, NOT OBLIGATORY
          // upper_cost_limit: 200.0, // upper cost limit of room in USD, NOT OBLIGATORY
          quantity: search_data.rooms, // Quantity of rooms, 1 by default, NOT OBLIGATORY
          rate_rq: {
            room_rq_id,
            tariff_rq_id,
          },
        },
      };

      const postObject = getPostObject({
        action: 'GetHotelPriceAlphaRQ',
        user_id: userId,
        refpartner,
        language: locale,
        // ##### Komarov 2025-05-26
        sale: sale || null,
        data,
      });

      // ##### Komarov 2025-09-02
      uniLog(
        'hotelrates.js',
        'axios:src/Redux/actions/hotelrates.js:getHotelRates4, url:',
        postObject.url
      );

      // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
      await postSavingDataClient({
        postObject,
        typeRes: GET_HOTEL_RATES_RES4,
        typeErr: GET_HOTEL_RATES_ERR4,
        dispatch,
      });
    };
